"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEqualDepth = isEqualDepth;
function isEqualDepth(value1, value2, depth = 5) {
    if (depth === 0) {
        return true;
    }
    if (value1 === value2) {
        return true;
    }
    if (typeof value1 !== 'object' ||
        typeof value2 !== 'object' ||
        value1 == null ||
        value2 == null) {
        return false;
    }
    if (Array.isArray(value1) && Array.isArray(value2)) {
        if (value1.length !== value2.length) {
            return false;
        }
        for (let i = 0; i < value1.length; i += 1) {
            if (!isEqualDepth(value1[i], value2[i], depth - 1)) {
                return false;
            }
        }
        return true;
    }
    const keys1 = Object.keys(value1);
    const keys2 = Object.keys(value2);
    if (keys1.length !== keys2.length) {
        return false;
    }
    for (const key of keys1) {
        if (!keys2.includes(key)) {
            return false;
        }
        if (!isEqualDepth(value1[key], value2[key], depth - 1)) {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=index.js.map